<template>
  <div class="ai-unavailable pa-4 d-flex flex-column align-center text-center">
    <v-icon
      size="32"
      color="warning"
      class="mb-2"
      >mdi-robot-off-outline</v-icon
    >
    <p class="text-subtitle-2 font-weight-bold mb-1">
      {{ t('ai-assistant.unavailable.title') }}
    </p>
    <p class="text-caption text-medium-emphasis mb-4">
      {{ t('ai-assistant.unavailable.body') }}
    </p>
    <v-btn
      color="primary"
      variant="flat"
      class="mb-2"
      @click="switchNow"
    >
      {{ t('ai-assistant.unavailable.switch-cta') }}
    </v-btn>
    <p class="text-caption text-disabled mb-0">
      {{ t('ai-assistant.unavailable.countdown', { seconds: secondsLeft }) }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { useAiAssistantStore } from '@/stores/aiAssistant'

const AUTO_SWITCH_SECONDS = 10

const { t } = useI18n()
const aiStore = useAiAssistantStore()

const secondsLeft = ref(AUTO_SWITCH_SECONDS)
let timer: ReturnType<typeof setInterval> | null = null

const clearTimer = (): void => {
  if (timer !== null) {
    clearInterval(timer)
    timer = null
  }
}

// Both the button and the countdown funnel through the same store action so
// they do exactly one thing; the timer is always cleared first.
const switchNow = (): void => {
  clearTimer()
  aiStore.switchToManualOnboarding()
}

onMounted(() => {
  timer = setInterval(() => {
    secondsLeft.value -= 1
    if (secondsLeft.value <= 0) {
      switchNow()
    }
  }, 1000)
})

onBeforeUnmount(clearTimer)
</script>

<style scoped>
.ai-unavailable {
  border-top: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  background: rgba(var(--v-theme-warning), 0.04);
}
</style>
